<template>
  <div class="w-100">
    <div class="accordion">
      <b-card no-body>
        <b-card-header @click="setIsOpen" header-tag="header" role="tab">
          <div class="row">
            <div class="col-6 accordion__title">
              <b-icon
                  icon="arrow-down-short"
                  variant="dark"
              >
              </b-icon>
              <strong>
                {{ $t('modal.segment.locale_rule_title') }}
              </strong>
            </div>
            <div class="d-flex justify-content-end align-items-center col-6 text-right">
              <p v-if="isEdited" class="text-danger mr-5 mb-0">{{ $t('error.segment.segment_is_edited') }}</p>
              <p v-if="v.locales.$dirty && v.locales.$invalid" class="text-danger mr-5 mb-0">{{ $t('error.segment.segment_required') }}</p>
              <button @click="destroy" class="btn btn-xs btn-danger delete-translation-btn">{{ $t('btn.segment.delete_segment') }}</button>
            </div>
          </div>
        </b-card-header>
        <b-collapse :visible="isOpen" accordion="locale" role="tabpanel">
          <div style="height: 400px;">
            <div class="row p-4 d-flex justify-content-center align-items-start">
              <div class="col-6">
                <p>{{$t('segment.set_locale')}}</p>
              </div>
              <div class="col-6">
                <multiselect
                    @input="emitSelectedValue('locales')"
                    :state="!v.locales.$dirty ? null :(!v.locales.$error)"
                    v-model="locales"
                    :options="options.localeRule"
                    :multiple="true"
                    track-by="value"
                    label="text">
                </multiselect>
                <div class="">
                  <p v-if="v.locales.$dirty && v.locales.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                </div>
              </div>
            </div>
            <div class="row p-4 d-flex justify-content-center align-items-start">
              <div class="col-6">
                <p>{{$t('segment.set_operation')}}</p>
              </div>
              <div class="col-6">
                <b-form-select v-model="operation" @change="emitSelectedValue('operation')" :state="!v.operation.$dirty ? null :(!v.operation.$error)" :options="options.operation"></b-form-select>
                <div class="">
                  <p v-if="v.operation.$dirty && v.operation.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                </div>
              </div>
            </div>
            <div class="row pr-4 d-flex justify-content-center align-items-start">
              <div class="col-12">
                <button v-if="isEditType" :disabled="!isEdited" @click="saveEditedRule" class="float-right btn btn-xs btn-success">{{ $t('btn.segment.save_edited_rule') }}</button>
              </div>
              </div>
          </div>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import {userSegment} from "../../../../common/constants/userSegment";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect
  },
  props: {
    v: {
      type: Object,
      required: true
    },
    localeForm: Object,
    isEditType: {
      type: Boolean,
      default: false
    },
    ruleId: {
      type: String,
      default: null,
      required: false
    },
    methodPost: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    localeDict: function () {
      return this.$store.getters['root/locale'];
    },
    isEdited: function () {
      return this.$store.getters[`userSegment/getEditedRule`](userSegment.locale);
    }
  },
  mounted() {
    this.localeDict.forEach(locale => {
      const option = {
        value: locale.name,
        text: locale.label
      }

      this.options.localeRule.push(option);
    });

    this.$parent.$on('checkValidation', () => {
      this.v.$touch();
    });

    if(this.localeForm.locales.length > 0) {
      this.locale = this.localeForm.locales;
      this.operation = this.localeForm.operation;

      this.locale = this.options.localeRule.filter(rule => {
        if(this.localeForm.locale.includes(rule.locale)) {
          return rule;
        }
      });
    }
  },
  data() {
    return {
      isOpen: false,
      locales: [],
      operation: '',
      options: {
        localeRule: [
          { value: null, text: this.$t('segment.locale_placeholder'), $isDisabled: true }
        ],
        operation: [
          {value: 'IN', text: this.$t('segment.option.in')},
          {value: 'NOT_IN', text: this.$t('segment.option.not_in')}
        ]
      }
    }
  },
  methods: {
    saveEditedRule() {
      this.$parent.$emit('editRule', {type: userSegment.locale, ruleId: this.ruleId, methodPost: this.methodPost});
    },
    deleteSegmentRule() {
      this.$parent.$emit('deleteSegmentRule', this.ruleId);
    },
    destroy() {
      const data = {
        component: this,
        rule: userSegment.locale,
        ruleId: this.ruleId
      }

      this.$parent.$emit('removeLocaleRule', data);
    },
    setIsOpen() {
      if(this.isEditType && !this.isEdited) {
        this.isOpen = !this.isOpen;
        return;
      } else if(this.isEditType && this.isEdited) {
        return;
      }

      this.isOpen = !this.isOpen;
    },
    emitSelectedValue(type) {
      if(this.isEditType) {
        const data = {
          key: userSegment.locale,
          value: true
        }

        this.$store.commit('userSegment/setEditedRule', data);
      }
      this.$parent.$emit('selectedLocale', {type: type, locale: this.locales, operation: this.operation});
    }
  }
}
</script>